export type Language = 'en' | 'da' | 'de' | 'fr' | 'es' | 'it' | 'ko' | 'ja' | 'zh'

export const translations = {
    "top-dealers": {
        en: "Top dealers in {country}",
        da: "Topforhandlere i {country}",
        de: "Top-Händler in {country}",
        fr: "Meilleurs revendeurs en {country}",
        es: "Mejores distribuidores en {country}",
        it: "Migliori rivenditori in {country}",
        ko: "우수 대리점 – {country}",
        ja: "優良販売店（{country}）",
        zh: "优质经销商（{country}）"
    },
    "nearby-dealers":{
        en: "Top dealers near {city}",
        de: "Top-Händler nahe {city}",
        fr: "Meilleurs revendeurs près de {city}",
        es: "Mejores distribuidores cerca de {city}",
        it: "Migliori rivenditori vicino a {city}",
        ko: "{city} 인근 우수 대리점",
        ja: "{city} 周辺の優良販売店",
        zh: "{city} 附近的优质经销商",
        da: "Topforhandlere nær {city}"
    },
    "visit-website": {
        en: "Visit website",
        de: "Webseite besuchen",
        fr: "Visiter le site web",
        es: "Visitar sitio web",
        it: "Visita il sito web",
        ko: "웹사이트 방문",
        ja: "ウェブサイトを訪問",
        zh: "访问网站",
        da: "Besøg hjemmeside"
    },
    "call-now": {
        en: "Call now",
        de: "Jetzt anrufen",
        fr: "Appeler maintenant",
        es: "Llamar ahora",
        it: "Chiama ora",
        ko: "지금 전화하기",
        ja: "今すぐ電話",
        zh: "立即拨打",
        da: "Ring nu"
    },
    "search-label": {
        en: "Search for a dealer",
        da: "Søg efter en forhandler",
        de: "Händler suchen",
        fr: "Rechercher un revendeur",
        es: "Buscar un distribuidor",
        it: "Cerca un rivenditore",
        ko: "대리점 검색",
        ja: "販売店を検索",
        zh: "搜索经销商"
    },
    "search-placeholder": {
        en: "City, region or postal code",
        da: "By, region eller postnummer",
        de: "Stadt, Region oder Postleitzahl",
        fr: "Ville, région ou code postal",
        es: "Ciudad, región o código postal",
        it: "Città, regione o CAP",
        ko: "도시, 지역 또는 우편번호",
        ja: "都市、地域または郵便番号",
        zh: "城市、地区或邮政编码"
    },
    "skip-to-content": {
        en: "Skip to content",
        da: "Gå til indhold",
        de: "Zum Inhalt springen",
        fr: "Aller au contenu",
        es: "Ir al contenido",
        it: "Vai al contenuto",
        ko: "본문으로 건너뛰기",
        ja: "本文へスキップ",
        zh: "跳至主要内容"
    },
    "home": {
        en: "LINDBERG Home",
        da: "LINDBERG forside",
        de: "LINDBERG Startseite",
        fr: "Accueil LINDBERG",
        es: "Inicio de LINDBERG",
        it: "Home LINDBERG",
        ko: "LINDBERG 홈",
        ja: "LINDBERG ホーム",
        zh: "LINDBERG 首页"
    },
    "nav-main": {
        en: "Main",
        da: "Hovedmenu",
        de: "Hauptmenü",
        fr: "Menu principal",
        es: "Menú principal",
        it: "Menu principale",
        ko: "주 메뉴",
        ja: "メインメニュー",
        zh: "主菜单"
    },
    "nav-utility": {
        en: "Utility",
        da: "Værktøjer",
        de: "Service",
        fr: "Utilitaires",
        es: "Utilidades",
        it: "Utilità",
        ko: "유틸리티",
        ja: "ユーティリティ",
        zh: "实用工具"
    },
    "menu-open": {
        en: "Menu",
        da: "Menu",
        de: "Menü",
        fr: "Menu",
        es: "Menú",
        it: "Menu",
        ko: "메뉴",
        ja: "メニュー",
        zh: "菜单"
    },
    "menu-close": {
        en: "Close menu",
        da: "Luk menu",
        de: "Menü schließen",
        fr: "Fermer le menu",
        es: "Cerrar menú",
        it: "Chiudi menu",
        ko: "메뉴 닫기",
        ja: "メニューを閉じる",
        zh: "关闭菜单"
    },
    "customise": {
        en: "customise",
        da: "tilpas",
        de: "anpassen",
        fr: "personnaliser",
        es: "personalizar",
        it: "personalizza",
        ko: "커스터마이즈",
        ja: "カスタマイズ",
        zh: "定制"
    },
    "video-play": {
        en: "Play video",
        da: "Afspil video",
        de: "Video abspielen",
        fr: "Lire la vidéo",
        es: "Reproducir vídeo",
        it: "Riproduci video",
        ko: "동영상 재생",
        ja: "動画を再生",
        zh: "播放视频"
    },
    "video-mute": {
        en: "Mute video",
        da: "Slå lyd fra",
        de: "Ton aus",
        fr: "Couper le son",
        es: "Silenciar vídeo",
        it: "Disattiva audio",
        ko: "음소거",
        ja: "ミュート",
        zh: "静音"
    },
    "video-unmute": {
        en: "Unmute video",
        da: "Slå lyd til",
        de: "Ton an",
        fr: "Activer le son",
        es: "Activar sonido",
        it: "Attiva audio",
        ko: "음소거 해제",
        ja: "ミュート解除",
        zh: "取消静音"
    },
} satisfies Record<string, Record<Language, string>>

// Looks up a label in the page language (or the given one), falling back to English,
// and fills in {placeholders} from values
export function translate(key: keyof typeof translations, values: Record<string, string> = {}, language = document.documentElement.lang) {
    const lang = language.toLowerCase().split('-')[0] as Language
    const text: string = translations[key][lang] ?? translations[key].en
    return Object.entries(values).reduce((acc, [name, value]) => acc.replace(`{${name}}`, value), text)
}
